// Product detail page: products/<product id>.html (id comes from <body data-id>)
(function () {
  const e = LC.escape;
  const main = document.getElementById('product-main');
  const id = LC.param('id');
  const p = LC.findProduct(id);

  // Products without site content keep the Shopify-rendered page underneath
  if (!p) return;

  const path = LC.productUrl(p.id);
  const col = LC.collections[p.category];
  const group = LC.groupOf(p);
  const groupCol = LC.collections[group];
  const hasPrice = p.price != null;
  // Products Shopify doesn't sell yet show their price with a notify link instead of Add to Bag
  const soldOut = LC.isSoldOut ? LC.isSoldOut(p) : false;
  const canBuy = hasPrice && p.available !== false && !soldOut;
  const isTool = ['flat-irons', 'blow-dryers', 'curling', 'travel'].includes(p.category)
    || (p.category === 'grooming' && /brush|straightener/i.test(p.name));
  const gallery = p.images.length ? p.images : [LC.productImage(p)];
  const multi = p.options.length > 1;
  const useSelect = multi && (p.optionLabel === 'Shade' || p.options.length > 10);
  const tagline = (p.description.match(/^[^.!?]+[.!?]/) || [p.description])[0];
  const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  const the = LC.the(p);

  let optionIndex = 0;
  let qty = 1;
  let plan = 'once';
  const isCare = group === 'care';
  const currentOption = () => (p.options[optionIndex] ? p.options[optionIndex].name : '');
  const currentSku = () => (p.options[optionIndex] && p.options[optionIndex].sku) || p.sku || '';

  /* ---------- Gallery ---------- */
  const firstImg = LC.productImage(p);
  const galleryHTML = `
    <div class="gallery2${gallery.length > 1 ? '' : ' single'}">
      ${gallery.length > 1 ? `
        <div class="thumbs2" role="group" aria-label="${e(p.name)} images">
          ${gallery.map((img, i) => `
            <button type="button" data-thumb="${i}" aria-pressed="${i === 0}" aria-label="View ${e(img.alt)}">
              <img src="${e(img.src)}" alt="" loading="lazy" width="120" height="120">
            </button>`).join('')}
        </div>` : ''}
      <div class="gmain2">
        <img id="pdp-image" src="${e(firstImg.src)}" alt="${e(firstImg.alt)}" width="1400" height="1400">
        ${firstImg.lifestyle ? '<span class="ph-note">Product photo coming soon</span>' : ''}
      </div>
    </div>`;

  /* ---------- Options ---------- */
  let optionsHTML = '';
  if (multi && p.optionLabel === 'Shade') {
    // Extension shades: a tap-to-choose grid of round swatches
    optionsHTML = `
      <div class="opts">
        <p class="opts-label" id="shade-label">${e(p.optionLabel)} · <span id="pdp-option-name">${e(currentOption())}</span></p>
        <div class="shade-grid" role="radiogroup" aria-labelledby="shade-label">
          ${p.options.map((o, i) => {
            const s = LC.shadeSwatch(o.name);
            return `<button type="button" class="dot shade-swatch${i === 0 ? ' on' : ''}" role="radio" aria-checked="${i === 0}" data-index="${i}"
              aria-label="${e(o.name)}${s.isNew ? ' (new shade)' : ''}" title="${e(o.name)}" style="--c:${e(s.bg)}">${s.isNew ? '<span class="shade-new" aria-hidden="true">New</span>' : ''}</button>`;
          }).join('')}
        </div>
        <p class="shade-help">Match your extension shade to the ends of your hair, not the root. Need help choosing? <a href="pages/contact.html">Ask for a shade match</a> or read the <a href="pages/extensions-guide.html#shades">shade guide</a>.</p>
      </div>`;
  } else if (multi && useSelect) {
    optionsHTML = `
      <div class="opts">
        <label class="opts-label" for="pdp-option-select">${e(p.optionLabel)} · <span id="pdp-option-name">${e(currentOption())}</span></label>
        <select id="pdp-option-select" class="shade-sel">
          ${p.options.map((o, i) => `<option value="${i}">${e(o.name)}</option>`).join('')}
        </select>
        ${p.optionLabel === 'Shade' ? `<p class="shade-help">Match your extension shade to the ends of your hair, not the root. Need help choosing? <a href="pages/contact.html">Ask for a shade match</a> or read the <a href="pages/extensions-guide.html#shades">shade guide</a>.</p>` : ''}
      </div>`;
  } else if (multi) {
    optionsHTML = `
      <div class="opts">
        <p class="opts-label">Color · <span id="pdp-option-name">${e(currentOption())}</span></p>
        <div class="dots" role="radiogroup" aria-label="${e(p.name)} color">
          ${p.options.map((o, i) => `
            <button type="button" class="dot${i === 0 ? ' on' : ''}" role="radio" aria-checked="${i === 0}" data-index="${i}"
              aria-label="${e(o.name)}" title="${e(o.name)}" style="--c:${LC.swatchColor(o.name)}"></button>`).join('')}
        </div>
      </div>`;
  }

  /* ---------- Purchase options (hair care only): one-time or Subscribe & Save ---------- */
  const subPct = Math.round(LC.subscription.discount * 100);
  const purchaseHTML = isCare && hasPrice ? `
    <div class="purchase-wrap">
      <p class="opts-label" id="plan-label">Purchase option</p>
      <div class="purchase" role="radiogroup" aria-labelledby="plan-label">
        <label class="on">
          <input type="radio" name="plan" id="plan-once" value="once" checked>
          <span class="pc-copy"><b>One-time purchase</b><span>${LC.formatPrice(p.price)}</span></span>
        </label>
        <label>
          <input type="radio" name="plan" id="plan-sub" value="sub">
          <span class="pc-copy"><b>Subscribe &amp; Save <em class="pc-save">${subPct}% off</em></b><span>${LC.formatPrice(LC.subPrice(p.price))} ${e(LC.subscription.cadence)} · cancel any time</span></span>
        </label>
      </div>
    </div>` : '';

  /* ---------- Buy box ---------- */
  const buyHTML = canBuy
    ? `<div class="buy">
         <div class="qty-pill">
           <button type="button" id="q-minus" aria-label="Decrease quantity">−</button>
           <span id="q-val" aria-live="polite">1</span>
           <button type="button" id="q-plus" aria-label="Increase quantity">+</button>
         </div>
         <button type="button" class="btn btn-dark" id="pdp-add">Add to Bag · ${LC.formatPrice(p.price)}</button>
       </div>`
    : soldOut
      ? `<div class="buy buy-soldout">
           <button type="button" class="btn btn-dark" disabled>Sold Out</button>
           <a class="btn btn-outline-navy" href="#notify">Notify Me</a>
         </div>`
      : `<div class="buy"><a class="btn btn-outline-navy" href="#notify">Notify Me When Available</a></div>`;

  const shipLine = `${isTool ? 'Limited Lifetime Warranty on registered hair tools · ' : ''}Typically ships within 1–2 business days`;

  const quickHTML = p.features.length
    ? `<ul class="pben">${p.features.slice(0, 3).map((f) => `<li><span class="bicon">${LC.icon(LC.iconFor(f))}</span><span>${e(cap(f))}</span></li>`).join('')}</ul>`
    : '';

  /* ---------- Accordion ---------- */
  const panels = [
    ['Details', `<p>${e(p.description)}</p>${p.features.length ? `<ul>${p.features.map((f) => `<li>${e(f)}</li>`).join('')}</ul>` : ''}`],
    p.benefits.length && ['Benefits', `<ul>${p.benefits.map((b) => `<li><strong>${e(b.title)}${b.text ? ':' : ''}</strong> ${e(b.text)}</li>`).join('')}</ul>`],
    p.directions.length && ['How to Use', `<ol>${p.directions.map((d) => `<li>${e(d)}</li>`).join('')}</ol>`],
    p.highlights.length && ['Technology & Features', `<ul class="depth">${p.highlights.map((h) => `<li><strong>${e(h.title)}</strong>${h.text ? `<span>${e(h.text)}</span>` : ''}</li>`).join('')}</ul>`],
    p.ingredients && ['Ingredients', `<p class="ing">${e(p.ingredients)}</p>`],
    ['Shipping & Returns', `<p>Le Chic Beauty orders typically ship within 1–2 business days, with tracking. You may cancel your order the same day it is placed, before it ships. Once shipped, orders cannot be cancelled. If your order has already shipped, you may request a return/refund within 30 days of delivery; return shipping is paid by the customer and restocking fees apply.${isTool ? ' Hair tools are covered by the Le Chic Beauty Limited Lifetime Warranty when registered within 14 days of purchase.' : ''}</p>`]
  ].filter(Boolean);

  /* ---------- Benefit strip ---------- */
  const strip = p.benefits.length
    ? p.benefits.map((b) => ({ icon: LC.iconFor(`${b.title} ${b.text}`), title: cap(b.title), text: cap(b.text || '') }))
    : p.features.map((f) => ({ icon: LC.iconFor(f), title: cap(f), text: '' }));
  if (isTool) strip.push({ icon: 'shield', title: 'Limited Lifetime Warranty', text: 'On registered hair tools' });
  if (p.category === 'extensions') strip.push({ icon: 'strand', title: '100% Remy human hair', text: 'Cuticle intact for a natural blend' });
  strip.push({ icon: 'bag', title: 'Ships in 1–2 business days', text: 'Every order is tracked' });
  const stripHTML = `
    <section class="benefit-strip" aria-label="${e(p.name)} benefits">
      <ul class="container bstrip">
        ${strip.slice(0, 6).map((s) => `<li><span class="bicon">${LC.icon(s.icon)}</span><strong>${e(s.title)}</strong>${s.text ? `<span>${e(s.text)}</span>` : ''}</li>`).join('')}
      </ul>
    </section>`;

  /* ---------- How-to video + steps ---------- */
  const video = p.videos[0] || { title: `How to use ${the}`, poster: LC.howToPoster(p) };
  const playable = Boolean(video.src || video.youtube);

  // Every product gets a short film built from its own photos, steps and features
  // (a filmed video in p.videos takes its place when there is one).
  const sentences = (p.description.match(/[^.!?]+[.!?]/g) || []).map((s) => s.trim()).filter((s) => s.length > 12);
  const filmSteps = (p.directions.length ? p.directions : p.features.length ? p.features : sentences)
    .slice(0, 4)
    .map((s) => cap(String(s).trim()));
  const filmScenes = [
    { kind: 'open', seconds: 3.2 },
    ...(p.directions.length && p.features.length ? [{ kind: 'product', seconds: 3.8 }] : []),
    ...filmSteps.map((text, i) => ({ kind: 'step', text, n: i + 1, seconds: Math.min(6, Math.max(3.6, text.length / 22)) })),
    { kind: 'close', seconds: 3.6 }
  ];
  const filmSeconds = Math.round(filmScenes.reduce((sum, s) => sum + s.seconds, 0));
  const hasFilm = !playable && filmSteps.length > 0;
  const filmTitle = p.directions.length ? video.title : `Meet ${the}`;

  const howToHTML = (p.directions.length || playable || hasFilm) ? `
    <section class="section" id="how-to" aria-labelledby="howto-title">
      <div class="container">
        <div class="section-head">
          <div>
            <p class="chip chip-greige">${p.directions.length ? 'Step by Step' : 'The Film'}</p>
            <h2 id="howto-title">${p.directions.length ? `How to Use ${e(the)}` : `Meet ${e(the)}`}</h2>
          </div>
          <p class="section-intro">${playable ? 'Watch the tutorial, then follow the step-by-step guide.'
            : p.directions.length ? `Watch the ${filmSeconds}-second film, then follow the ${p.directions.length} steps for the best results.`
              : `A ${filmSeconds}-second look at ${e(the)}.`}</p>
        </div>
        <div class="howto-grid${p.directions.length ? '' : ' is-film-only'}">
          <div class="video-card" id="video-card">
            <img src="${e(video.poster || LC.howToPoster(p))}" alt="" loading="lazy">
            <button type="button" class="video-play"${playable || hasFilm ? '' : ' disabled'} aria-label="${playable ? `Play video: ${e(video.title)}` : hasFilm ? `Play the ${filmSeconds}-second film: ${e(filmTitle)}` : 'Video coming soon'}">${LC.icon('play')}</button>
            <div class="video-caption">
              <span class="chip chip-light">${playable ? 'Video tutorial' : hasFilm ? `Watch · 0:${String(filmSeconds).padStart(2, '0')}` : 'Video coming soon'}</span>
              <strong>${e(hasFilm ? filmTitle : video.title)}</strong>
            </div>
          </div>
          ${p.directions.length ? `
            <ol class="howto-steps">
              ${p.directions.map((step, i) => `<li><span class="step-num">${String(i + 1).padStart(2, '0')}</span><p>${e(step)}</p></li>`).join('')}
            </ol>` : ''}
        </div>
      </div>
    </section>` : '';

  /* ---------- FAQ ---------- */
  const faqs = LC.faqsFor(p);
  const faqHTML = faqs.length ? `
    <section class="section faq2" id="faq" aria-labelledby="faq-title">
      <div class="container faq2-grid">
        <div class="faq2-aside">
          <p class="chip">Ask Le Chic Beauty</p>
          <h2 id="faq-title">${e(p.name)} FAQ</h2>
          <p>Answers to the most common questions about ${e(the)}. Anything else? <a href="pages/contact.html">Contact Le Chic Beauty Customer Care</a>.</p>
        </div>
        <div class="faq2-list">
          ${faqs.map((f, i) => `
            <details${i === 0 ? ' open' : ''}>
              <summary>${e(f.q)}</summary>
              <p>${e(f.a)}</p>
            </details>`).join('')}
        </div>
      </div>
    </section>` : '';

  /* ---------- Lifestyle banner + related ---------- */
  const life = LC.collectionImage(group);
  const related = [
    ...LC.products.filter((x) => x.category === p.category && x.id !== p.id),
    ...LC.featured().filter((x) => x.category !== p.category)
  ].slice(0, 4);

  main.innerHTML = `
    <section class="pdp-hero">
      <div class="container">
        <nav class="breadcrumb" aria-label="Breadcrumb">
          <ol>
            <li><a href="index.html">Home</a></li>
            <li><a href="${LC.collectionUrl(group)}">${e(groupCol.name)}</a></li>
            ${group !== p.category && LC.collectionSeo[p.category] ? `<li><a href="${LC.collectionUrl(p.category)}">${e(col.name)}</a></li>` : ''}
            <li aria-current="page">${e(p.name)}</li>
          </ol>
        </nav>
        <div class="pdp2">
          ${galleryHTML}
          <div class="pinfo">
            <p class="pline"><a href="${LC.collectionUrl(p.category)}">${e(col.name)}</a></p>
            <h1>${e(p.name)}</h1>
            <p class="ptag">${e(tagline)}</p>
            ${currentSku() ? `<p class="psku">SKU <span id="sku-val">${e(currentSku())}</span></p>` : ''}
            <p class="pprice" id="pdp-price">${hasPrice ? LC.formatPrice(p.price) : 'Price coming soon'}</p>
            ${optionsHTML}
            ${purchaseHTML}
            ${buyHTML}
            <p class="ship">${shipLine}</p>
            ${quickHTML}
            <div class="acc2">
              ${panels.map(([title, body], i) => `
                <details${i === 0 ? ' open' : ''}>
                  <summary>${title}</summary>
                  <div class="acc-body">${body}</div>
                </details>`).join('')}
            </div>
          </div>
        </div>
      </div>
    </section>

    ${stripHTML}
    ${howToHTML}
    ${faqHTML}

    <div class="container">
      <section class="pdp-life2" aria-labelledby="life-title">
        <div class="life-media"><img src="${e(life.src)}" alt="${e(life.alt)}" loading="lazy"></div>
        <div class="q">
          <p class="life-eyebrow">${e(groupCol.eyebrow || groupCol.name)}</p>
          <h2 id="life-title">${e(LC.collectionSeo[group] ? LC.collectionSeo[group].h1 : groupCol.name)}</h2>
          <p>${e(groupCol.description)}</p>
          <a class="btn" href="${LC.collectionUrl(group)}">Shop ${e(groupCol.name)}</a>
        </div>
      </section>
    </div>

    ${related.length ? `
      <section class="section section-mist" aria-labelledby="related-title">
        <div class="container">
          <div class="section-head">
            <div>
              <p class="chip">Curated for You</p>
              <h2 id="related-title">Complete Your Routine</h2>
            </div>
            <a class="link-arrow" href="${LC.collectionUrl(p.category)}">Shop all ${e(col.name)} <span aria-hidden="true">→</span></a>
          </div>
          <div class="product-grid">${related.map(LC.cardHTML).join('')}</div>
        </div>
      </section>` : ''}

    ${canBuy ? `
      <div class="mobile-buy" id="mobile-buy">
        <div><strong>${e(p.name)}</strong><span>${LC.formatPrice(p.price)}</span></div>
        <button type="button" class="btn btn-dark" id="mobile-add">Add to Bag</button>
      </div>` : ''}`;

  /* ---------- SEO: title, meta, canonical, structured data ---------- */
  const pageTitle = `${p.name} | Le Chic Beauty`;
  const metaCore = `${p.name}${hasPrice ? ` (${LC.formatPrice(p.price)})` : ''}: ${tagline}`;
  const metaExtra = isTool ? ' Lifetime warranty when registered.' : ' Ships in 1–2 business days.';
  const metaDesc = (metaCore + metaExtra).length <= 158 ? metaCore + metaExtra : metaCore;
  const crumbs = [['Home', 'index.html'], [groupCol.name, LC.collectionUrl(group)]];
  if (group !== p.category && LC.collectionSeo[p.category]) crumbs.push([col.name, LC.collectionUrl(p.category)]);
  crumbs.push([p.name, path]);
  LC.seo({
    title: pageTitle,
    description: metaDesc,
    path,
    image: gallery[0].src,
    imageAlt: gallery[0].alt,
    type: 'product',
    jsonld: [
      LC.webPageLd('ItemPage', path, pageTitle, p.description, {
        breadcrumb: { '@id': `${LC.abs(path)}#breadcrumb` },
        mainEntity: { '@id': `${LC.abs(path)}#product` },
        primaryImageOfPage: LC.abs(gallery[0].src)
      }),
      Object.assign(LC.breadcrumbLd(crumbs), { '@id': `${LC.abs(path)}#breadcrumb` }),
      LC.productLd(p, path),
      LC.faqLd(faqs, path),
      LC.howToLd(`How to use ${the}`, tagline, p.directions.map((d, i) => ({ name: `Step ${i + 1}`, text: d })), path, gallery[0].src)
    ]
  });

  /* ---------- Behavior ---------- */
  const mainImg = document.getElementById('pdp-image');
  const thumbBtns = Array.from(main.querySelectorAll('[data-thumb]'));

  function showImage(src, alt) {
    mainImg.src = src;
    mainImg.alt = alt;
    const note = main.querySelector('.ph-note');
    if (note) note.remove();
    thumbBtns.forEach((b) => b.setAttribute('aria-pressed', String(gallery[Number(b.dataset.thumb)].src === src)));
  }
  thumbBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const img = gallery[Number(btn.dataset.thumb)];
      showImage(img.src, img.alt);
    });
  });

  const addBtn = document.getElementById('pdp-add');
  function updateBuy() {
    const skuEl = document.getElementById('sku-val');
    if (skuEl) skuEl.textContent = currentSku();
    if (!canBuy) return;
    const unit = plan === 'sub' ? LC.subPrice(p.price) : p.price;
    document.getElementById('q-val').textContent = qty;
    addBtn.textContent = `${plan === 'sub' ? 'Subscribe' : 'Add to Bag'} · ${LC.formatPrice(unit * qty)}`;
    document.getElementById('pdp-price').innerHTML = plan === 'sub'
      ? `${LC.formatPrice(unit)} <s>${LC.formatPrice(p.price)}</s>`
      : LC.formatPrice(p.price);
  }

  function selectOption(index) {
    optionIndex = index;
    const option = p.options[index];
    document.getElementById('pdp-option-name').textContent = option.name;
    main.querySelectorAll('.dot').forEach((d) => {
      const on = Number(d.dataset.index) === index;
      d.classList.toggle('on', on);
      d.setAttribute('aria-checked', String(on));
    });
    if (option.image) showImage(option.image, `${p.name} in ${option.name}`);
    updateBuy();
  }
  main.querySelectorAll('.dot').forEach((d) => d.addEventListener('click', () => selectOption(Number(d.dataset.index))));
  const optionSelect = document.getElementById('pdp-option-select');
  if (optionSelect) optionSelect.addEventListener('change', () => selectOption(Number(optionSelect.value)));

  if (canBuy) {
    document.getElementById('q-minus').addEventListener('click',() => { qty = Math.max(1, qty - 1); updateBuy(); });
    document.getElementById('q-plus').addEventListener('click', () => { qty = Math.min(10, qty + 1); updateBuy(); });
    main.querySelectorAll('input[name="plan"]').forEach((radio) => radio.addEventListener('change', () => {
      plan = radio.value;
      main.querySelectorAll('.purchase label').forEach((l) => l.classList.toggle('on', l.contains(radio)));
      updateBuy();
    }));
    const add = () => LC.bag.add(p.id, qty, currentOption(), plan);
    addBtn.addEventListener('click', add);
    document.getElementById('mobile-add').addEventListener('click', add);
  }

  // Video player: supports a hosted file (video.src) or YouTube (video.youtube = video id)
  const videoCard = document.getElementById('video-card');
  if (videoCard && playable) {
    videoCard.querySelector('.video-play').addEventListener('click', () => {
      videoCard.classList.add('is-playing');
      videoCard.innerHTML = video.youtube
        ? `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(video.youtube)}?autoplay=1&rel=0" title="${e(video.title)}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`
        : `<video src="${e(video.src)}" controls autoplay playsinline></video>`;
    });
  }

  // Product film player: scenes cross-fade with story-style progress bars, pause and replay
  if (videoCard && hasFilm) {
    // Prefer the blue-packaging photo (hair care) so the film matches the brand look
    const productImg = LC.blueImage ? LC.blueImage(p) : LC.productImage(p);
    const lifestyle = video.poster || LC.howToPoster(p);
    const tagline =(groupCol && groupCol.tagline) || (col && col.tagline) || 'Your signature finish';
    const pauseIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5h3v14H8zM13 5h3v14h-3z" fill="currentColor"/></svg>';
    const playIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7L8 5Z" fill="currentColor"/></svg>';
    const replayIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.3-5.7"/><path d="M4 4v4h4"/></svg>';

    const sceneHTML = (s, i) => {
      const d = `style="--d:${s.seconds}s"`;
      if (s.kind === 'open') {
        return `
          <div class="film-scene film-open" data-scene="${i}" ${d}>
            <img class="film-bg" src="${e(lifestyle)}" alt="">
            <div class="film-copy">
              <span class="film-kicker">${p.directions.length ? 'How to use' : 'Meet'}</span>
              <strong class="film-title">${e(p.name)}</strong>
            </div>
          </div>`;
      }
      if (s.kind === 'product') {
        return `
          <div class="film-scene film-product" data-scene="${i}" ${d}>
            <img class="film-pack" src="${e(productImg.src)}" alt="">
            <ul class="film-points">${p.features.slice(0, 3).map((f, j) => `<li style="--j:${j}">${e(cap(f))}</li>`).join('')}</ul>
          </div>`;
      }
      if (s.kind === 'step') {
        return `
          <div class="film-scene film-step" data-scene="${i}" ${d}>
            <div class="film-step-copy">
              <span class="film-num">${String(s.n).padStart(2, '0')}<small>/ ${String(filmSteps.length).padStart(2, '0')}</small></span>
              <p>${e(s.text)}</p>
            </div>
            <div class="film-step-media"><img src="${e(productImg.src)}" alt=""></div>
          </div>`;
      }
      return `
        <div class="film-scene film-close" data-scene="${i}" ${d}>
          <img class="film-bg" src="${e(lifestyle)}" alt="">
          <div class="film-copy">
            <span class="film-kicker">${e(tagline)}</span>
            <strong class="film-title">${e(p.name)}</strong>
            ${hasPrice && p.available !== false ? `<button type="button" class="btn btn-light film-cta">Add to Bag · ${LC.formatPrice(p.price)}</button>` : ''}
          </div>
        </div>`;
    };

    const playFilm = () => {
      videoCard.classList.add('is-playing', 'is-film');
      videoCard.innerHTML = `
        <div class="lc-film" role="group" aria-roledescription="video" aria-label="Film: ${e(filmTitle)}">
          <div class="film-bars" aria-hidden="true">${filmScenes.map((s) => `<span style="--d:${s.seconds}s"><i></i></span>`).join('')}</div>
          <div class="film-stage">${filmScenes.map(sceneHTML).join('')}</div>
          <div class="film-controls">
            <button type="button" class="film-btn film-toggle" aria-label="Pause film">${pauseIcon}</button>
            <button type="button" class="film-btn film-replay" aria-label="Replay film">${replayIcon}</button>
          </div>
          <p class="sr-only film-live" aria-live="polite"></p>
        </div>`;

      const film = videoCard.querySelector('.lc-film');
      const scenes = Array.from(film.querySelectorAll('.film-scene'));
      const bars = Array.from(film.querySelectorAll('.film-bars span'));
      const live = film.querySelector('.film-live');
      const toggleBtn = film.querySelector('.film-toggle');
      let index = 0;
      let paused = false;
      let timer = 0;
      let sceneStart = 0; // when the current scene last started or resumed
      let remaining = 0; // ms left in the current scene

      const show = (i) => {
        index = i;
        scenes.forEach((el) => el.classList.remove('is-on'));
        bars.forEach((b) => b.classList.remove('is-on'));
        void film.offsetWidth; // restart CSS animations
        scenes[i].classList.add('is-on');
        bars.forEach((b, j) => { b.classList.toggle('is-done', j < i); b.classList.toggle('is-on', j === i); });
        const s = filmScenes[i];
        live.textContent = s.kind === 'step' ? `Step ${s.n}: ${s.text}` : s.kind === 'open' ? filmTitle : '';
      };
      const setControls = () => {
        film.classList.toggle('is-paused', paused);
        toggleBtn.innerHTML = paused ? playIcon : pauseIcon;
        toggleBtn.setAttribute('aria-label', paused ? 'Play film' : 'Pause film');
      };
      // A plain clock (not animation frames) so the film keeps time in every browser
      const schedule = (ms) => {
        clearTimeout(timer);
        remaining = ms;
        sceneStart = performance.now();
        timer = setTimeout(() => {
          if (index < filmScenes.length - 1) {
            show(index + 1);
            schedule(filmScenes[index].seconds * 1000);
          } else {
            film.classList.add('is-ended');
            bars.forEach((b) => { b.classList.add('is-done'); b.classList.remove('is-on'); });
            paused = true;
            setControls();
          }
        }, ms);
      };
      const setPaused = (value) => {
        if (value === paused) return;
        if (value) {
          clearTimeout(timer);
          remaining = Math.max(0, remaining - (performance.now() - sceneStart));
        } else {
          schedule(remaining);
        }
        paused = value;
        setControls();
      };
      const start = () => {
        clearTimeout(timer);
        film.classList.remove('is-ended');
        paused = false;
        setControls();
        show(0);
        schedule(filmScenes[0].seconds * 1000);
      };

      toggleBtn.addEventListener('click', () => {
        if (film.classList.contains('is-ended')) start();
        else setPaused(!paused);
      });
      film.querySelector('.film-replay').addEventListener('click', start);
      const cta = film.querySelector('.film-cta');
      if (cta) cta.addEventListener('click', () => LC.bag.add(p.id, 1, currentOption(), plan));
      start();
      toggleBtn.focus({ preventScroll: true });
    };
    videoCard.querySelector('.video-play').addEventListener('click', playFilm);
  }

  // Sticky add-to-bag bar on small screens once the main button scrolls away
  const mobileBuy = document.getElementById('mobile-buy');
  if (mobileBuy && addBtn && 'IntersectionObserver' in window) {
    document.body.classList.add('has-mobile-buy');
    new IntersectionObserver(([entry]) => {
      mobileBuy.classList.toggle('show', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(addBtn);
  }
})();
